import Joi from 'joi-browser';
import i18n from './translations.utils';
const t = i18n.getTranslation.bind(i18n);

const MasterValidationSchema = {
  name: Joi.string()
    .regex(/^[a-zA-Z\s-]+$/, 'name')
    .min(3)
    .max(30)
    .required()
    .error(errors => FormErrors(errors)),
  firstName: Joi.string()
    .regex(/^[a-zA-Z\s-]+$/, 'firstName')
    .min(3)
    .max(30)
    .required()
    .error(errors => FormErrors(errors)),
  lastName: Joi.string()
    .regex(/^[a-zA-Z\s-]+$/, 'lastName')
    .min(3)
    .max(30)
    .required()
    .error(errors => FormErrors(errors)),
  phoneNumber: Joi.string()
    .regex(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, 'phoneNumber')
    .min(0)
    .max(10)
    .required()
    .error(errors => FormErrors(errors)),
  gender: Joi.string()
    .required()
    .error(errors => FormErrors(errors)),
  ageRange: Joi.string()
    .required()
    .error(errors => FormErrors(errors)),
  dob: Joi.date()
    .min(new Date(new Date().setFullYear(new Date().getFullYear() - 100)).toISOString().split('T')[0])
    .max(new Date(new Date().setFullYear(new Date().getFullYear() - 13)).toISOString().split('T')[0])
    .required()
    .error(errors => FormErrors(errors)),
  email: Joi.string()
    .email({ minDomainAtoms: 2 })
    .required()
    .error(errors => FormErrors(errors)),
  postalCode: Joi.string()
    .required()
    .error(errors => FormErrors(errors)),
  required: Joi.string()
    .required()
    .error(errors => FormErrors(errors)),
};

const userPINameSchema = {
  name: MasterValidationSchema.name,
};
const newsLetterValidationSchema = {
  name: MasterValidationSchema.name,
  firstName: MasterValidationSchema.firstName,
  lastName: MasterValidationSchema.lastName,
  phoneNumber: MasterValidationSchema.phoneNumber,
  dob: MasterValidationSchema.dob,
  email: MasterValidationSchema.email,
  required: MasterValidationSchema.required,
};
const FormErrors = errors => {
  return errors.length === 1 ? 'xyz' : '';
};

const convertcamelCaseToTitleCase = (text: string) => {
  const result = text.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

const handleErrorTranslation = async (type, context, field) => {
  let translatedError = '';

  switch (type) {
    case 'string.min':
      let contextLabel = field;
      contextLabel = contextLabel ? convertcamelCaseToTitleCase(contextLabel) : contextLabel;

      console.log('changes for names');
      if (field === 'firstName') {
        console.log('changes for name');
        translatedError = `${await t('form.error.field.fisrtName')} ${await t('form.error.chr.first')} ${context.limit} ${await t('form.error.chr.second')}`;
      } else if (field === 'lastName') {
        translatedError = `${await t('form.error.field.lastName')} ${await t('form.error.chr.first')} ${context.limit} ${await t('form.error.chr.second')}`;
      } else {
        translatedError = `${contextLabel} ${await t('form.error.chr.first')} ${context.limit} ${await t('form.error.chr.second')}`;
      }
      break;

    case 'any.empty':
      translatedError = await t('form.error.isrequired.default');
      field === 'firstName' && (translatedError = await t('form.error.isrequired.firstname'));
      field === 'lastName' && (translatedError = await t('form.error.isrequired.lastname'));
      field === 'name' && (translatedError = await t('form.error.isrequired.name'));
      field === 'phoneNumber' && (translatedError = await t('form.error.isrequired.phnnumber'));
      field === 'ageRange' && (translatedError = await t('form.error.isrequired.ageRange'));
      field === '1239' && (translatedError = await t('form.error.isrequired.default'));
      field === '1649' && (translatedError = await t('form.error.isrequired.default'));
      field === 'required' && (translatedError = await t('form.error.isrequired.default'));
      field === 'postalCode' && (translatedError = await t('form.error.isrequired.postalCode'));
      field === 'dob' && (translatedError = await t('form.error.isrequired.dob'));
      field === 'gender' && (translatedError = await t('form.error.isrequired.gender'));
      field === 'email' && (translatedError = await t('form.error.isrequired.email'));
      field === 'verificationCode' && (translatedError = await t('form.error.isrequired.verificationCode'));
      field === 'password' && (translatedError = await t('form.error.password.required'));
      field === 'oldPassword' && (translatedError = await t('form.error.oldPassword.required'));
      field === 'confirmPassword' && (translatedError = await t('form.error.password.confirm'));

      break;

    case 'string.email':
      translatedError = await t('newsletter-signup.emailFieldError');

      break;

    case 'string.regex.name':
      if (field === 'firstName') {
        translatedError = await t('form.error.invalid.firstname');
      } else if (field === 'lastName') {
        translatedError = await t('form.error.invalid.lastname');
      } else if (field === 'name') {
        translatedError = await t('form.error.invalid.name');
      } else if (field === 'phoneNumber') {
        translatedError = await t('form.error.invalid.phnnumber');
        break;
      } else if (field === 'verificationCode') {
        translatedError = await t('form.error.invalid.verificationCode');
      } else if (field === 'postalCode') {
        translatedError = await t('form.error.invalid.postalCode');
      } else {
        translatedError = await t('form.error.password.regex');
      }

      break;

    case 'date.base':
      translatedError = t('form.error.date.invalid');
      break;

    case 'date.min':
      translatedError = `${await t('form.error.date.limit')} ${context.limit.toISOString().split('T')[0]}`;

      break;

    case 'date.max':
      translatedError = `${await t('form.error.date.limit.max')} `;

      break;

    case 'any.required':
      field === 'firstName' && (translatedError = await t('form.error.isrequired.firstname'));
      field === 'lastName' && (translatedError = await t('form.error.isrequired.lastname'));
      field === 'name' && (translatedError = await t('form.error.isrequired.name'));
      field === 'phoneNumber' && (translatedError = await t('form.error.isrequired.phnnumber'));
      field === 'gender' && (translatedError = await t('form.error.isrequired.gender'));
      field === 'ageRange' && (translatedError = await t('form.error.isrequired.ageRange'));
      field === 'postalCode' && (translatedError = await t('form.error.isrequired.postalCode'));
      field === 'required' && (translatedError = await t('form.error.isrequired.default'));
      field === 'dob' && (translatedError = await t('form.error.isrequired.dob'));
      field === 'email' && (translatedError = await t('form.error.isrequired.email'));
      field === 'verificationCode' && (translatedError = await t('form.error.isrequired.verificationCode'));
      field === 'password' && (translatedError = await t('form.error.password.required'));
      field === 'oldPassword' && (translatedError = await t('form.error.oldPassword.required'));
      field === 'confirmPassword' && (translatedError = await t('form.error.password.confirm'));

      break;

    default:
      break;
  }

  return translatedError;
};

const validateField = async (name, value, schema) => {
  const obj = {
    [name]: value,
  };
  const result = Joi.validate(obj, schema);
  const errorInput = document.querySelector('aiba-app').shadowRoot?.querySelector(`[name=${name}]`) as HTMLElement;
  const resetErrorBorder = () => {
    const errorText = errorInput.nextSibling as HTMLElement;
    if (errorText.className === 'input-error') {
      errorInput.classList.add('error');
    } else {
      errorInput.classList?.remove('error');
    }
  };

  if (result.error) {
    const translatedError = await handleErrorTranslation(result.error.details[0].type, result.error.details[0].context, name);

    result.error = {
      ...result.error,
      message: translatedError,
      details: [{ message: translatedError }],
    };

    result.message = translatedError;

    setTimeout(resetErrorBorder, 200);
  } else {
    errorInput.classList?.remove('error');
  }

  return result.error ? result.error : result;
};
export { userPINameSchema, FormErrors, validateField, newsLetterValidationSchema };
